import Cookies from 'universal-cookie'
import PropTypes from 'prop-types'

const cookies = new Cookies()
const queryParams = new URLSearchParams(window.location.search)

export function objectToQueryString(obj) {
  var str = []
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]))
    }
  return str.join('&')
}

export function paramsToObject(entries) {
  const result = {}
  for (const [key, value] of entries) {
    // each 'entry' is a [key, value] tupple
    result[key] = value
  }
  return result
}

export const chunk = (arr, size) => {
  return arr.reduce((acc, val, ind) => {
    const subIndex = ind % size
    if (!Array.isArray(acc[subIndex])) {
      acc[subIndex] = [val]
    } else {
      acc[subIndex].push(val)
    }
    return acc
  }, [])
}

export const strLimit = (str, limit) => {
  if (str) {
    if (str.length >= limit - 3) {
      return str.substring(0, limit) + '...'
    }
  }
  return str
}

export const removeHtmlTags = (str) => {
  if (str) {
    return str.replace(/(<([^>]+)>)/gi, '')
  }
  return str
}

export const getParameterByName = (name, url = window.location.href) => {
  name = name.replace(/[\[\]]/g, '\\$&')
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  console.log('url' + url)
  console.log('results[2]' + results[2])
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

export const capitalizeFirstLetter = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
}

export const capitalizeWords = (str) => {
  return str
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

export const setPricing = (cV, dC) => {
  var currencyValue = cV === undefined || cV === null ? '' : cV.toString()
  var discountCode = dC === undefined || dC === null ? '' : dC.toString()
  var price = '45'
  var getSlug = ''
  getSlug = '/api/get-fee-data/' + currencyValue + '/' + discountCode
  return axios
    .get(getSlug)
    .then((response) => {
      if (JSON.stringify(response.data) === '{}') {
        let returnData = {
          membershipFee: price,
          feeSlug: 'annual-membership-fee-eur',
        }
        return returnData
      } else {
        console.log('data')
      }
      return response.data
    })
    .catch((e) => {
      console.log('Request failure: ', e)
      return price
    })
}

export const setPayAsYouChoosePricing = (pV, cV) => {
  var getSlug = ''
  var currencyValue =
    cV === undefined || cV === null || cV === '' ? 'EUR' : cV.toString()
  getSlug = '/api/get-payc-fee-data/' + pV + '/' + currencyValue

  console.log('getSlug: ' + getSlug)

  return axios
    .get(getSlug)
    .then((response) => {
      return response.data
    })
    .catch((e) => {
      console.log('Request failure: ', e)
      return price
    })
}

export const setSubscriptionPricing = (sT, cV, pT) => {
  var getSlug = ''
  var currencyValue =
    cV === undefined || cV === null || cV === '' ? 'EUR' : cV.toString()
  getSlug = '/api/get-subs-fee-data/' + sT + '/' + currencyValue + '/' + pT

  console.log('pT: ' + pT)
  console.log('cV: ' + cV)
  console.log('currencyValue: ' + currencyValue)
  console.log('getSlug: ' + getSlug)

  return axios
    .get(getSlug)
    .then((response) => {
      return response.data
    })
    .catch((e) => {
      console.log('Request failure: ', e)
      return price
    })
}

export const getCurrencySign = (cV) => {
  let getSlug = '/api/get-currency-sign/' + cV
  return axios
    .get(getSlug)
    .then((response) => {
      return response.data
    })
    .catch((e) => {
      console.log('Request failure: ', e)
    })
}

export const textTranslation = (originalTextArr, toLang) => {
  console.log('textTranslation...')

  let fromLang = 'en'
  var translatedTextArr = []
  const API_KEY = googleMapsApiKey
  let url = `https://translation.googleapis.com/language/translate/v2?key=${API_KEY}`
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      q: originalTextArr,
      source: fromLang,
      target: toLang,
    }),
  })
    .then((res) => res.json())
    .then((response) => {
      let translations = response['data']['translations']
      translations.forEach(function (item) {
        translatedTextArr.push(item['translatedText'])
      })
      return translatedTextArr
    })
    .catch((error) => {
      return originalTextArr
    })
}

export const shouldTranslateTo = () => {
  if (
    cookies.get('lC') !== '' &&
    cookies.get('lC') !== null &&
    cookies.get('lC') !== undefined &&
    cookies.get('lC') !== 'en'
  ) {
    return cookies.get('lC')
  } else if (
    queryParams.get('lc') !== '' &&
    queryParams.get('lc') !== null &&
    queryParams.get('lc') !== undefined &&
    queryParams.get('lc') !== 'en'
  ) {
    return queryParams.get('lc')
  } else {
    return 'en'
  }
}

export const getCurrentLanguageName = ($languageCode) => {
  /*
    var getSlug = '';
    getSlug = '/api/currentLanguage/' + $languageCode;
    return axios
        .get(getSlug)
        .then(response => {
            return response.data;
        })
        .catch((e) => {
            console.log('Request failure: ', e);
            return price;
        });
    */
  switch ($languageCode) {
    case 'de':
      return 'Deutsch'
    case 'en':
      return 'English'
    case 'es':
      return 'Español'
    case 'fr':
      return 'Français'
    case 'it':
      return 'Italiano'
    case 'pt':
      return 'Português'
    case 'us':
      return 'English'
  }
}

export const isValidEmail = (email) => {
  return /\S+@\S+\.\S+/.test(email)
}

export const isInPhoneScreen = () => {
  return window.innerWidth <= 768
}

export const isTablet = window.matchMedia(
  '(min-width: 768px) and (max-width: 1024px)'
).matches
